module.exports = __webpack_public_path__ + "secondPartLanding.jpg";